// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__10L_S","title":"BackImages_title__3MZjD","images":"BackImages_images__23h41"};